export default __webpack_public_path__ + "static/media/paper-plane.c56a1b03.png";